import { createSlice } from "@reduxjs/toolkit";

export const nameSlice = createSlice({
  name: "name",
  initialState: {
    name: "John Doe",
  },
  reducers: {
    setFullName: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFullName } = nameSlice.actions;

export default nameSlice.reducer;
